import { layoutText } from '../elements/text/textLayout';

export const applyTextWidthFromTransform = (node, element) => {
  const scaleXSign = Math.sign(node.scaleX() || 1) || 1;
  const absScaleX = Math.abs(node.scaleX() || 1);
  const nextWidth = Math.max(10, (node.width() || element?.width || 10) * absScaleX);
  const nextHeight = Math.max(10, layoutText(element, nextWidth).height);

  node.scaleX(scaleXSign);
  node.scaleY(1);
  node.width(nextWidth);
  node.offsetX(nextWidth / 2);
  node.height(nextHeight);
  node.offsetY(nextHeight / 2);

  ['.ms-text', '.ms-text-bg', '.ms-text-backdrop'].forEach((selector) => {
    node.findOne(selector)?.size({ width: nextWidth, height: nextHeight });
  });

  return {
    x: node.x(),
    y: node.y(),
    width: nextWidth,
    height: nextHeight,
    rotation: node.rotation(),
    scaleX: scaleXSign,
    scaleY: 1,
  };
};

export const bakeImageTransformEnd = (node, element, { minHeight = 10 } = {}) => {
  const scaleXSign = Math.sign(node.scaleX() || 1) || 1;
  const scaleYSign = Math.sign(node.scaleY() || 1) || 1;
  const absScaleX = Math.abs(node.scaleX());
  const absScaleY = Math.abs(node.scaleY());

  const nextWidth = Math.max(10, (node.width() || element?.width || 10) * absScaleX);
  const nextHeight = Math.max(minHeight, (node.height() || element?.height || minHeight) * absScaleY);

  node.scaleX(scaleXSign);
  node.scaleY(scaleYSign);
  node.offsetX(nextWidth / 2);
  node.offsetY(nextHeight / 2);
  node.width(nextWidth);
  node.height(nextHeight);

  return {
    x: node.x(),
    y: node.y(),
    width: nextWidth,
    height: nextHeight,
    rotation: node.rotation(),
    scaleX: scaleXSign,
    scaleY: scaleYSign,
  };
};
